export const GIT_DIFF_STRATEGIES = [
    { id: "current", label: "Current", description: "The production Git patch rendered by Pierre" },
    { id: "whole-file", label: "Whole file", description: "Pierre aligns the complete before and after snapshots" },
    { id: "move-aware", label: "Move-aware", description: "VS Code matching separates moved blocks from residual edits" },
    { id: "low-noise", label: "Low-noise", description: "Move-aware matching with trim-only whitespace ignored" },
    { id: "difftastic", label: "Difftastic", description: "Optional tree-sitter structural diff from the local Nest" },
] as const

export type GitDiffStrategy = (typeof GIT_DIFF_STRATEGIES)[number]["id"]

export function normalizeGitDiffStrategy(value: unknown): GitDiffStrategy {
    return GIT_DIFF_STRATEGIES.some((strategy) => strategy.id === value) ? (value as GitDiffStrategy) : "current"
}
